import Vue from "vue";
import VueRouter from "vue-router";
import { ensureValidToken, hasRole, clearTokens, REQUIRED_ROLE } from "@/utils/auth";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: () => import("@/views/LoginPage.vue"),
  },
  {
    path: "/app",
    component: () => import("@/components/Layout/Layout.vue"),
    meta: { requiresAuth: true },
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("@/views/mainPage.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "user",
        name: "User",
        component: () => import("@/views/userDetails.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "inbox",
        name: "Inbox",
        component: () => import("@/views/InboxPage.vue"),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: "/dashboard",
    redirect: "/app/dashboard",
  },
  {
    path: "/user",
    redirect: "/app/user",
  },
  {
    path: "*", // catch-all redirect
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

// True when there is a usable session (refreshing the access token if it has
// expired) whose token carries the required role.
async function hasValidSession() {
  const token = await ensureValidToken();
  return Boolean(token) && hasRole(REQUIRED_ROLE, token);
}

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth) {
    if (await hasValidSession()) return next();
    clearTokens();
    return next({ path: "/", query: { redirect: to.fullPath } });
  }

  // Already signed in: skip the login page.
  if (to.path === "/" && (await hasValidSession())) {
    return next("/app/dashboard");
  }
  return next();
});

export default router;
